/**
 * `parseProjectCollaborationEvent` validates with `z.enum(...)` over the whole
 * enum, so every member is live even though none is named directly. Dropping
 * one would silently start rejecting that message type.
 * @public
 */
export enum ProjectCollaborationMessageType {
  UPDATE = "project.changes",
  VIEWERS = "project.viewers"
}

export type ProjectCollaborationChangeType = "create" | "update" | "delete"

export interface ProjectCollaborationChange {
  changeType: ProjectCollaborationChangeType
  // The PIS entity class name in lower case, e.g. `projectposition`.
  resourceType: string
  resourceId?: string
}

export interface ProjectCollaborationMessage {
  message: ProjectCollaborationMessageType
  project: { id: string }
  changes?: ProjectCollaborationChange[]
}
